import { Component, type ReactNode } from "react";
export class ErrorCatch extends Component<{children: ReactNode}, {err: Error | null}> {
  state = { err: null as Error | null };
  static getDerivedStateFromError(err: Error) { return { err }; }
  componentDidCatch(err: Error, info: any) { console.error("ErrorCatch:", err, info); }
  render() {
    if (this.state.err) {
      const e = this.state.err;
      return (
        <div style={{padding:20,fontFamily:"monospace",background:"#fee",color:"#900",whiteSpace:"pre-wrap"}}>
          <h2 style={{fontSize:18,fontWeight:700}}>Error en la página</h2>
          <p><b>Mensaje:</b> {e.message}</p>
          <p><b>Stack:</b></p>
          <pre style={{fontSize:11,overflow:"auto",background:"#fff",padding:8,borderRadius:4}}>{e.stack}</pre>
        </div>
      );
    }
    return this.props.children as any;
  }
}
export default ErrorCatch;
